export default [
  {
    path: '/ticketing',
    name: 'ticketing-user',
    component: () => import('@/views/pages/komship/ticketing-user/Ticketing.vue'),
    meta: {
      name: 'ticketing-user',
      routeToDetail: 'detail-ticketing-user',
      resource: 'Tiket Kendala',
      action: 'manage',
    },
  },
  {
    path: '/ticketing/detail/:ticket_id',
    name: 'detail-ticketing-detail-order',
    component: () => import('@/views/pages/komship/detail-ticketing-user/DetailTicketing.vue'),
    meta: {
      name: 'detail-ticketing-user',
      routeTicket: 'ticketing-user',
      routeToDetailOrder: 'detail-ticketing-detail-order',
      routeDetailOrder: 'detail-order',
      navActiveLink: 'ticketing-user',
      resource: 'Tiket Kendala',
      action: 'manage',
    },
  },
  {
    path: '/monitoring-claim',
    name: 'monitoring-claim',
    component: () => import('@/views/pages/komship/monitoring-claims/MonitoringClaims.vue'),
    meta: {
      name: 'monitoring-claim',
      routeToDetail: 'monitoring-claim',
      resource: 'Monitoring Claim',
      action: 'manage',
    },
  },
  {
    path: '/ticketing/respon-massal',
    name: 'respon-massal',
    component: () => import('@/views/pages/komship/ticketing-user/response-massal/ResponseMassal.vue'),
    meta: {
      name: 'respon-massal',
      routeTicket: 'ticketing-user',
      routeToDetailOrder: 'respon-massal',
      navActiveLink: 'ticketing-user',
      resource: 'Tiket Kendala',
      action: 'manage',
    },
  },
]
